import React, { useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text, VStack } from '@adc/parallax-component-library';
import { useApiError, useLibrePractice, useToast } from 'Hooks';
import { Link, Main, TitleActionBar } from 'Components/utility';
import { applyPhoneNumberMask } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const PracticeConnection = ({ data: { practiceConnection } }) => {
    const [footerLoading, setFooterLoading] = useState(false);
    const { removePractice, showStopSharingModal } = useLibrePractice();
    const { showToast } = useToast();
    const { showApiErrorModal } = useApiError();
    if (!practiceConnection) {
        mediator.publish('router:navigate', '/connections');
        return null;
    }
    const onStopSharing = () => {
        showStopSharingModal(async () => {
            try {
                setFooterLoading(true);
                await removePractice(practiceConnection.practiceId);
                showToast({
                    message: i18n.t('Connections.modals.practiceRemovedToast.body'),
                    'aria-label': i18n.t('Connections.modals.practiceRemovedToast.body'),
                    icon: undefined,
                });
                mediator.publish('router:navigate', '/connections');
            }
            catch {
                showApiErrorModal();
            }
            finally {
                setFooterLoading(false);
            }
        });
    };
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "PracticeConnection", title: practiceConnection.name, onBack: () => {
                mediator.publish('router:navigate', '/connections');
            } }),
        React.createElement(Stack, { margin: "$4", padding: "$4", backgroundColor: "$surface.container", border: "$1.5", shadow: "$1" },
            React.createElement(Text, { testID: "PracticeConnection.title", color: "$text.100", fontWeight: "$h4.strong", fontSize: "$h4.strong", marginBottom: "$2" }, i18n.t('Connections.content.connectedPractice.primaryText')),
            React.createElement(Text, { testID: "PracticeConnection.secondaryText", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100" }, i18n.t('Connections.content.connectedPractice.secondaryText')),
            React.createElement(VStack, { marginTop: "$4" },
                React.createElement(Text, { testID: "PracticeConnection.practiceID.label", color: "$text.60", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", marginBottom: "$0.5" }, i18n.t('Connections.content.connectedPractice.formField.practiceID.label')),
                React.createElement(Text, { testID: "PracticeConnection.practiceID", color: "$text.100", fontSize: "$bodyBase.medium", fontWeight: "$bodyBase.medium" }, practiceConnection.businessId),
                React.createElement(Divider, { marginVertical: "$4" }),
                React.createElement(Text, { testID: "PracticeConnection.practiceAddress.label", color: "$text.60", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", marginBottom: "$0.5" }, i18n.t('Connections.content.connectedPractice.formField.practiceAddress.label')),
                React.createElement(Text, { testID: "PracticeConnection.practiceAddress", color: "$text.100", fontSize: "$bodyBase.medium", fontWeight: "$bodyBase.medium" }, `${practiceConnection.address1}, ${practiceConnection.city}, ${practiceConnection.state} ${practiceConnection.zip}`),
                React.createElement(Divider, { marginVertical: "$4" }),
                React.createElement(Text, { testID: "PracticeConnection.practicePhoneNumber.label", color: "$text.60", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", marginBottom: "$0.5" }, i18n.t('Connections.content.connectedPractice.formField.practicePhoneNumber.label')),
                React.createElement(Text, { testID: "PracticeConnection.practicePhoneNumber", color: "$text.100", fontSize: "$bodyBase.medium", fontWeight: "$bodyBase.medium" }, applyPhoneNumberMask(practiceConnection.phoneNumber)),
                React.createElement(Divider, { marginVertical: "$4", borderColor: "$neutral.40" }),
                footerLoading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center" },
                    React.createElement(LoadingSpinner, null))) : (React.createElement(Link, { testID: "PracticeConnection.stopSharing-btn", onPress: onStopSharing, textColor: "$support.danger.default" }, i18n.t('Connections.content.connectedPractice.bodyText')))))));
};
export default PracticeConnection;
